import { render, staticRenderFns } from "./Guochuang.vue?vue&type=template&id=2e392c20&"
import script from "./Guochuang.vue?vue&type=script&lang=js&"
export * from "./Guochuang.vue?vue&type=script&lang=js&"
import style0 from "./Guochuang.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports